import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBarCanvas } from '@nivo/bar';
import { colors } from './styles';

const ChartColumn = props => (
  <ResponsiveBarCanvas
    margin={{
      top: 20,
      right: 50,
      bottom: 150,
      left: 130
    }}
    padding={0.3}
    colors={colors}
    colorBy="index"
    borderColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: -35
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: props.axisLeftLegend,
      legendPosition: 'middle',
      legendOffset: -80,
      format: props.format
    }}
    labelSkipWidth={12}
    labelSkipHeight={12}
    labelTextColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    layout="vertical"
    animate={false}
    maxValue="auto"
    minValue="auto"
    {...props}
  />
);

ChartColumn.propTypes = {
  axisLeftLegend: PropTypes.string,
  format: PropTypes.func.isRequired,
  tooltipFormat: PropTypes.func.isRequired
};

ChartColumn.defaultProps = {
  axisLeftLegend: null
};

export default ChartColumn;
